import UniversalLoginForm from '@/domains/auth/components/login/UniversalLoginForm';

export default function LoginPage() {
    return <UniversalLoginForm />;
}